module.exports = __webpack_public_path__ + "img/student.288e9bc2.jpg";